import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import * as selectorsChild from '../selector';
import { createChild } from '../thunk';

import type { ChildJsonInput } from '@/domain/child/component/ChildFormInput';

import DialogTitle from '@/components/DialogTitle';
import DialogTransition from '@/components/DialogTransition';
import ChildFormInput from '@/domain/child/component/ChildFormInput';

/**
 * プロパティ
 */
export type AddChildImput = {
  /** 開いているか */
  isOpen: boolean,
  /** 開いているか設定 */
  setIsOpen: (isOpen: boolean) => void,
  /** 親ID */
  parentId: string,
  /** デフォルトの苗字 */
  familyName: string,
  /** デフォルトの苗字（かな） */
  familyNameKana: string,
}

const AddChild: React.FC<AddChildImput> = ({
  isOpen,
  setIsOpen,
  parentId,
  familyName,
  familyNameKana,
}) => {
  const dispatch = useDispatch();
  const childList = useSelector(selectorsChild.childListSelector);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<ChildJsonInput>({
    defaultValues: {
      childId: '',
      name: '',
      nameKana: '',
      familyName,
      familyNameKana,
      birthday: '',
      gender: '男',
    },
  });
  const onSubmit = (input: ChildJsonInput) => {
    dispatch(createChild({
      parentId,
      childId: input.childId,
      name: input.name,
      nameKana: input.nameKana,
      familyName: input.familyName,
      familyNameKana: input.familyNameKana,
      gender: input.gender,
      birthday: input.birthday,
    }));
    setIsOpen(false);
  };
  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      fullScreen
      TransitionComponent={DialogTransition}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle title="子どもの新規登録" />
        <DialogContent>
          <p>子どもID、子どもの苗字、名前、苗字（ひらがな）、名前（ひらがな）、誕生日、性別を入力してください。</p>
          <ChildFormInput
            control={control}
            errors={errors}
            childList={childList}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" type="submit" color="primary">
            新規登録
          </Button>
          <Button variant="contained" onClick={() => setIsOpen(false)} color="primary">
            閉じる
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddChild;
